export default __webpack_public_path__ + "static/media/laundry1-afterA-480w.c3999098.avif";